"use strict";

function withNaming(n) {
  return function (t, e) {
    return function (r, i, u) {
      var o = {
        b: t,
        e: e
      };
      return "string" == typeof r ? (o.e = r, Array.isArray(i) ? o.mix = i : (o.m = i, o.mix = u)) : (o.m = r, o.mix = i), function (t) {
        var e,
            r,
            i,
            u,
            o = (n.n || "") + t.b,
            c = [],
            m = o + (t.e ? n.e + t.e : "");
        return void 0 !== t.mix && t.mix.forEach(function (n) {
          if ("string" == typeof n && n) {
            var t = n.split(" ").filter(function (n) {
              return n !== m;
            });
            c.push.apply(c, t);
          }
        }), m += (e = t.m, r = e || Object.create(null), i = Object.keys(r).filter(function (n) {
          return r[n];
        }).map(function (n) {
          return !0 === r[n] ? [n] : [n, r[n]];
        }), u = n.v || n.m, i.length ? " " + i.map(function (e) {
          return (t.e ? o + n.e + t.e : o) + n.m + e.join(u);
        }).join(" ") : ""), c.length > 0 && (m += " " + c.join(" ")), m;
      }(o);
    };
  };
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});
var cn = withNaming({
  e: "-",
  m: "_"
});
exports.cn = cn, exports.withNaming = withNaming;